import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../../authentication/auth.service';
import { ApiServiceBase } from '../../base/api-service-base';
import { AttributeGroupReferenceModel } from '../../models/reference-model/reference-general-model/attribute-group-reference.model';

@Injectable({
  providedIn: 'root'
})
export class AttributeGroupReferenceService extends ApiServiceBase {
  private readonly PATH = "/system/AttributeGroupReference"

  constructor(httpClient: HttpClient,
    authService: AuthService) { 
      super(httpClient, authService)
    }

  public getAttributeGroupReference(): Observable<AttributeGroupReferenceModel[]> {
    return this.httpGet<AttributeGroupReferenceModel[]>(this.PATH, null)
      .pipe(
        map(response => response.body)
      )
  }
}
